import React, { lazy } from 'react';
export function Bonuses() {
  return <section className="bg-white py-10 sm:py-16 px-5" data-id="element-17">
      <div className="max-w-[860px] mx-auto" data-id="element-18">
        <div className="text-center mb-8 sm:mb-12" data-id="element-19">
          <h2 className="text-[clamp(22px,4vw,34px)] font-extrabold leading-[1.2] mb-3 text-oscuro uppercase" data-id="element-20">
            3 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-[15px] text-gris" data-id="element-21">
            Sin costo extra — incluidos en ambas ofertas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4" data-id="element-22">
          <div className="bg-white rounded-2xl p-4 sm:p-5 border-[1.5px] border-dashed border-[#E0D5F5] relative flex flex-col" data-id="element-23">
            <div className="absolute -top-2.5 left-4 bg-verde text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider z-10" data-id="element-24">
              Gratis
            </div>

            <div className="flex items-center gap-3 mb-3" data-id="element-25">
              <img src="https://images.unsplash.com/photo-1512428559087-560fa5ceab42?w=120&q=60&auto=format&fit=crop" alt="WhatsApp Business" loading="lazy" className="w-12 h-12 sm:w-14 sm:h-14 object-cover rounded-lg shadow-sm flex-shrink-0" data-id="element-26" />
              <div data-id="element-27">
                <div className="text-[10px] sm:text-[11px] font-bold text-violeta uppercase tracking-wider mb-0.5" data-id="element-28">
                  Bono 1
                </div>
                <strong className="block text-[13px] sm:text-[14px] font-bold text-oscuro leading-tight" data-id="element-29">
                  Guía de WhatsApp Business Profesional
                </strong>
              </div>
            </div>

            <p className="text-[12px] sm:text-[13px] text-gris leading-relaxed mb-2 flex-grow" data-id="element-30">
              Configurá tu perfil en 30 minutos: mensaje de bienvenida
              automático, mensaje de ausencia, las 10 respuestas rápidas
              esenciales del rubro y catálogo de servicios.
            </p>
            <p className="text-[11px] sm:text-[12px] text-violeta mt-1 italic leading-snug" data-id="element-31">
              Por qué lo necesitás: el 80% de tus consultas llegan por WhatsApp.
              Si tu perfil se ve amateur, la clienta ya te juzgó antes de que
              respondas.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-4 sm:p-5 border-[1.5px] border-dashed border-[#E0D5F5] relative flex flex-col" data-id="element-32">
            <div className="absolute -top-2.5 left-4 bg-verde text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider z-10" data-id="element-33">
              Gratis
            </div>

            <div className="flex items-center gap-3 mb-3" data-id="element-34">
              <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=120&q=60&auto=format&fit=crop" alt="Planilla Mensual" loading="lazy" className="w-12 h-12 sm:w-14 sm:h-14 object-cover rounded-lg shadow-sm flex-shrink-0" data-id="element-35" />
              <div data-id="element-36">
                <div className="text-[10px] sm:text-[11px] font-bold text-violeta uppercase tracking-wider mb-0.5" data-id="element-37">
                  Bono 2
                </div>
                <strong className="block text-[13px] sm:text-[14px] font-bold text-oscuro leading-tight" data-id="element-38">
                  Planilla de Rutina Mensual del Negocio
                </strong>
              </div>
            </div>

            <p className="text-[12px] sm:text-[13px] text-gris leading-relaxed mb-2 flex-grow" data-id="element-39">
              Tracker semanal de turnos, resumen de ingresos por tratamiento,
              registro de gastos y cálculo de ganancia neta real. 5 minutos por
              semana, 15 al cierre del mes.
            </p>
            <p className="text-[11px] sm:text-[12px] text-violeta mt-1 italic leading-snug" data-id="element-40">
              Por qué lo necesitás: lo que no se mide no se mejora. Esta
              planilla te dice exactamente cuánto ganás, cuánto gastás y cuál es
              tu tratamiento más rentable.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-4 sm:p-5 border-[1.5px] border-dashed border-[#E0D5F5] relative flex flex-col" data-id="element-41">
            <div className="absolute -top-2.5 left-4 bg-verde text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider z-10" data-id="element-42">
              Gratis
            </div>

            <div className="flex items-center gap-3 mb-3" data-id="element-43">
              <img src="https://images.unsplash.com/photo-1556761175-4b46a572b786?w=120&q=60&auto=format&fit=crop" alt="Cierre de Presupuesto" loading="lazy" className="w-12 h-12 sm:w-14 sm:h-14 object-cover rounded-lg shadow-sm flex-shrink-0" data-id="element-44" />
              <div data-id="element-45">
                <div className="text-[10px] sm:text-[11px] font-bold text-violeta uppercase tracking-wider mb-0.5" data-id="element-46">
                  Bono 3
                </div>
                <strong className="block text-[13px] sm:text-[14px] font-bold text-oscuro leading-tight" data-id="element-47">
                  Guión de Cierre de Presupuesto
                </strong>
              </div>
            </div>

            <p className="text-[12px] sm:text-[13px] text-gris leading-relaxed mb-2 flex-grow" data-id="element-48">
              Los mensajes exactos para hacer seguimiento a las 24hs, 3 días y 7
              días. Más las respuestas listas para las 5 objeciones más
              frecuentes y el tracker de presupuestos enviados.
            </p>
            <p className="text-[11px] sm:text-[12px] text-violeta mt-1 italic leading-snug" data-id="element-49">
              Por qué lo necesitás: el 70% de los presupuestos que no cierran no
              se pierden por el precio — se pierden porque nadie hizo el
              seguimiento correcto.
            </p>
          </div>
        </div>

        <div className="text-center mt-6 sm:mt-8 p-4 sm:p-5 bg-gradient-to-br from-rosa to-rosa-oscuro rounded-2xl text-white text-[14px] sm:text-[16px] font-bold shadow-md" data-id="element-50">
          VALOR TOTAL DE LOS BONOS: $18.000 — INCLUIDOS GRATIS EN TU KIT
        </div>
      </div>
    </section>;
}